module.exports = __webpack_public_path__ + "static/images/components/UpgradeIcon/images/arrow-3.625327e7.png";


//////////////////
// WEBPACK FOOTER
// ./components/UpgradeIcon/images/arrow-3.png
// module id = 2698
// module chunks = 11